import { render, staticRenderFns } from "./btn-languages.vue?vue&type=template&id=78d571d6&scoped=true"
import script from "./btn-languages.vue?vue&type=script&lang=js"
export * from "./btn-languages.vue?vue&type=script&lang=js"
import style0 from "./btn-languages.vue?vue&type=style&index=0&id=78d571d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d571d6",
  null
  
)

export default component.exports